/**
 * Usage: number | localCurrency:'format'
 * If no format is provided 2 decimals will be used.
 **/

import {Pipe, PipeTransform} from '@angular/core';
import {formatCurrency, getCurrencySymbol} from '@angular/common';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {AuthService} from '@app/core/services/auth.service';

@Pipe({
	name: 'localCurrency',
})
export class LocalCurrencyPipe implements PipeTransform {

	constructor(private interService: InternationalizationService, public authService: AuthService) {
	}

	public transform(value: any, digitsFormat?: string, format?: 'wide' | 'narrow', currency?: string, useSymbol: boolean = false): any {
		if (!currency) {
			currency = this.authService.tenant.language.currency;
		}
		if (value === null) {
			return '';
		}
		if (!format) {
			format = 'narrow';
		}
		let symbol = getCurrencySymbol(currency, format, this.interService.currentLocales.angularLocale);
		if (value === 'symbol') {
			return symbol;
		}
		if (!digitsFormat) {
			digitsFormat = '0.2-2';
		}
		if (!useSymbol) {
			symbol = currency;
		}

		return formatCurrency(value, this.interService.currentLocales.angularLocale, symbol + ' ', currency, digitsFormat);
	}
}
